/**
 * Canonical game identity — mirrors functions/game_identity.py for client-side dedupe.
 */

function normalizeTeam(name) {
  return String(name || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function normalizeStartKey(startTime) {
  if (startTime == null || startTime === '') return '';
  const text = String(startTime).trim();
  if (text.length >= 16) return text.slice(0, 16);
  if (text.length >= 10) return text.slice(0, 10);
  return text;
}

function teamDedupeLabel(game, side) {
  const keyField = `${side}Key`;
  if (game?.[keyField]) return normalizeTeam(game[keyField]);
  return normalizeTeam(game?.[side]);
}

/** sport + away + home + scheduled start — provider-agnostic. */
export function canonicalGameKey(game) {
  const sport = String(game?.sport || '').trim().toUpperCase();
  const away = teamDedupeLabel(game, 'a');
  const home = teamDedupeLabel(game, 'b');
  const start = normalizeStartKey(game?.startTime);
  return `teams:${sport}:${away}:${home}:${start}`;
}

/**
 * Defensive dedupe for display lists — by canonical key, then by id.
 * @param {object[]} games
 */
export function dedupeGamesForDisplay(games) {
  if (!Array.isArray(games)) return [];
  const seenKeys = new Set();
  const seenIds = new Set();
  const merged = [];
  for (const game of games) {
    const key = canonicalGameKey(game);
    if (key && seenKeys.has(key)) continue;
    const id = game?.id;
    if (id && seenIds.has(id)) continue;
    if (key) seenKeys.add(key);
    if (id) seenIds.add(id);
    merged.push(game);
  }
  return merged;
}
